import React from 'react';
import { connect } from 'react-redux';
import { actionCreators } from './action';

import Button from '@material-ui/core/Button';

const NewProjectButton = (props) =>  
<>
    <Button variant="contained" color="primary" onClick={()=> props.openNewProjectForm()}>
        New project
    </Button>
    </>
;

const mapStateToProps = (state) => ({
    test: state.test
});

export default connect(
  mapStateToProps,
  actionCreators
)(NewProjectButton)